module.exports = __webpack_public_path__ + "d050f12012c2eec5c5550a310eedfd76.pdf";